<div class="list-container">
  @for (element of (dataSource.filteredData | sortOrder); track element) {
  <mat-card>
    <mat-card-title>{{ element.name }}</mat-card-title>
    <mat-card-content>
      @if (element.startDate) {
      <p>
        {{
          element?.type !== 'ORDER'
            ? ('ORDERS.DASHBOARD.STARTDATE' | translate)
            : ('ORDERS.DASHBOARD.ORDERDATE' | translate)
        }}:
        <strong>{{ element?.type !== 'ORDER' ? element.startDate : formatArticleDate(element.startDate) }}</strong>
      </p>
      } @if (element.endDate) {
      <p>
        {{ 'ORDERS.DASHBOARD.ENDDATE' | translate }}: <strong>{{ element.endDate }}</strong>
      </p>
      } @if (element.recipient.firstName && element.recipient.lastName) {
      <p>
        {{ 'ORDERS.DASHBOARD.RECIPIENT' | translate }}:
        <strong>{{ element.recipient.firstName }} {{ element.recipient.lastName }}</strong>
      </p>
      <p>
        <small> {{ 'ORDERS.DASHBOARD.RECIPIENT_INFO' | translate }} </small>
      </p>
      }
      <p>
        {{ 'ORDERS.DASHBOARD.PRICE' | translate }}: <strong>{{ element.price }}</strong>
      </p>
      <p>
        {{ 'ORDERS.DASHBOARD.STATUS' | translate }}:
        <strong>{{
          element.type !== 'ORDER' ? mapSubscriptionsStatus(element.status) : mapArticleStatus(element.status)
        }}</strong>
      </p>
      @if (element.promotions && element.promotions.length > 0) {
      <mat-list>
        <mat-divider class="mat-divider-margin"></mat-divider>
        <mat-list-item> {{ 'ORDERS.DASHBOARD.DIGITAL_PROMOTIONS' | translate }}: </mat-list-item>
        <mat-divider class="mat-divider-margin"></mat-divider>

        @for (promotion of element.promotions; track promotion) {@if (promotion.download_url) {
        <mat-list-item>
          <button
            mat-button
            [disabled]="promotionsCurrentlyDownloading.includes($index)"
            (click)="downloadArticle(promotion.download_url, $index)"
            [class.button-spinner]="promotionsCurrentlyDownloading.includes($index)"
          >
            {{ promotion.attribute_name }}
          </button></mat-list-item
        >} }
      </mat-list>
      }
    </mat-card-content>
    <mat-card-actions>
      @if (hasComplaintFeature) {
      <button mat-raised-button color="primary" (click)="makeComplaint(element)">
        {{ 'ORDERS.DASHBOARD.COMPLAINT' | translate }}
      </button>
      } @if (hasInvoiceDownloadFeature) {
      <button
        mat-raised-button
        color="primary"
        [disabled]="element.uuid ? invoicesCurrentlyDownloading.includes(element.uuid) : false"
        [class.button-spinner]="element.uuid ? invoicesCurrentlyDownloading.includes(element.uuid) : false"
        (click)="downloadInvoices(element)"
      >
        <span>{{ 'ORDERS.DOWNLOAD_INVOICE' | translate }}</span>
      </button>
      } @if (element.downloadUrl) {
      <button
        mat-raised-button
        color="primary"
        [disabled]="articlesCurrentlyDownloading.includes(element.uuid)"
        (click)="downloadArticle(element.downloadUrl, undefined, element.uuid)"
        [class.button-spinner]="articlesCurrentlyDownloading.includes(element.uuid)"
      >
        {{ 'ORDERS.DOWNLOAD_ARTICLE' | translate }}
      </button>
      } @if (allowChangePaymentMethod && canChangeOrderPaymentMethod(element)) {
      <button
        mat-raised-button
        color="primary"
        [disabled]="element.status.toUpperCase() === 'CANCELED' || element.status.toUpperCase() === 'INACTIVE'"
        (click)="openPaymentMethods(element)"
      >
        {{ 'ORDERS.CHANGE_PAYMENT_METHOD_BUTTON.MOBILE' | translate }}
      </button>
      } @if (element.type !== 'ORDER' && hasCancellationFeature) {
      <button
        (click)="cancel(element)"
        mat-raised-button
        color="primary"
        [disabled]="
          element.status.toUpperCase() === 'CANCELED' ||
          element.status.toUpperCase() === 'INACTIVE' ||
          cancellationIsLoading
        "
        [class.button-spinner]="cancellationIsLoading"
      >
        {{ 'ORDERS.DASHBOARD.CANCEL_MOBILE' | translate }}
      </button>
      } @if (canRevocate) {@if (revocationCustomLink) {
      <a
        mat-raised-button
        color="primary"
        target="_blank"
        [href]="revocationCustomLink"
        [disabled]="
          element.status.toUpperCase() === 'CANCELED' ||
          element.status.toUpperCase() === 'INACTIVE' ||
          isRevocationLoading
        "
      >
        {{ 'ORDERS.DASHBOARD.REVOCATE' | translate }}
      </a>
      } @else {
      <button
        mat-raised-button
        color="primary"
        (click)="revocate(element)"
        [disabled]="
          element.status.toUpperCase() === 'CANCELED' ||
          element.status.toUpperCase() === 'INACTIVE' ||
          isRevocationLoading
        "
        [class.button-spinner]="isRevocationLoading"
      >
        {{ 'ORDERS.DASHBOARD.REVOCATE' | translate }}
      </button>
      }}
    </mat-card-actions> </mat-card
  >}
</div>

<!--<mat-sidenav-container class="sidenav-height">-->
<!--  <mat-sidenav #sidenav mode="over" (closed)="onClose()" position="end" style="position: absolute">-->
<!--    <div class="nav-header">-->
<!--      <button mat-icon-button (click)="sidenav.close(); onClose()">-->
<!--        <mat-icon>close</mat-icon>-->
<!--      </button>-->
<!--    </div>-->
<!--    <mat-list>-->
<!--      <mat-list-item *ngIf="expandedElement?.endDate">-->
<!--        {{ 'ORDERS.DASHBOARD.ENDDATE' | translate }}: {{ expandedElement?.endDate }}-->
<!--      </mat-list-item>-->
<!--      <mat-list-item>{{ 'ORDERS.DASHBOARD.PRICE' | translate }}: {{ expandedElement?.price }}</mat-list-item>-->
<!--      <mat-list-item>-->
<!--        @if (hasInvoiceDownloadFeature) {-->
<!--        <button-->
<!--          mat-button-->
<!--          color="primary"-->
<!--          [disabled]="expandedElement?.uuid ? invoicesCurrentlyDownloading.includes(expandedElement!.uuid) : false"-->
<!--          [class.button-spinner]="-->
<!--            expandedElement?.uuid ? invoicesCurrentlyDownloading.includes(expandedElement!.uuid) : false-->
<!--          "-->
<!--          (click)="downloadInvoices(expandedElement!)"-->
<!--        >-->
<!--          <span>{{ 'ORDERS.DOWNLOAD_INVOICE' | translate }}</span>-->
<!--        </button>-->
<!--        }-->
<!--      </mat-list-item>-->
<!--      <mat-list-item *ngIf="expandedElement?.downloadUrl">-->
<!--        <button-->
<!--          mat-button-->
<!--          color="primary"-->
<!--          [disabled]="articlesCurrentlyDownloading.includes(expandedElement!.uuid)"-->
<!--          (click)="downloadArticle(expandedElement!.downloadUrl, undefined, expandedElement!.uuid)"-->
<!--          [class.button-spinner]="articlesCurrentlyDownloading.includes(expandedElement!.uuid)"-->
<!--        >-->
<!--          {{ 'ORDERS.DOWNLOAD_ARTICLE' | translate }}-->
<!--        </button>-->
<!--      </mat-list-item>-->
<!--      <mat-divider class="mat-divider-margin"></mat-divider>-->
<!--      <mat-list-item>-->
<!--        {{ 'ORDERS.DASHBOARD.STATUS' | translate }}:-->
<!--        {{-->
<!--          expandedElement-->
<!--            ? expandedElement.type !== 'ORDER'-->
<!--              ? mapSubscriptionsStatus(expandedElement!.status)-->
<!--              : mapArticleStatus(expandedElement!.status)-->
<!--            : ''-->
<!--        }}-->
<!--      </mat-list-item>-->
<!--      <mat-list-item>-->
<!--        <button-->
<!--          mat-button-->
<!--          color="primary"-->
<!--          *ngIf="-->
<!--            allowChangePaymentMethod &&-->
<!--            (expandedElement?.type?.toUpperCase() === 'SUBSCR' || expandedElement?.type?.toUpperCase() === 'SUBSCRARC')-->
<!--          "-->
<!--          [disabled]="-->
<!--            expandedElement?.status?.toUpperCase() === 'CANCELED' ||-->
<!--            expandedElement?.status?.toUpperCase() === 'INACTIVE'-->
<!--          "-->
<!--          (click)="openPaymentMethods(expandedElement)"-->
<!--        >-->
<!--          {{ 'ORDERS.CHANGE_PAYMENT_METHOD_BUTTON.MOBILE' | translate }}-->
<!--        </button>-->
<!--      </mat-list-item>-->
<!--      <mat-list-item *ngIf="expandedElement?.type !== 'ORDER'">-->
<!--        @if (hasCancellationFeature) {<button-->
<!--          (click)="expandedElement ? cancel(expandedElement) : {}"-->
<!--          mat-button-->
<!--          color="primary"-->
<!--          [disabled]="-->
<!--            expandedElement?.status?.toUpperCase() === 'CANCELED' ||-->
<!--            expandedElement?.status?.toUpperCase() === 'INACTIVE' ||-->
<!--            cancellationIsLoading-->
<!--          "-->
<!--          [class.button-spinner]="cancellationIsLoading"-->
<!--        >-->
<!--          {{ 'ORDERS.DASHBOARD.CANCEL_MOBILE' | translate }}-->
<!--        </button>-->
<!--        }-->
<!--      </mat-list-item>-->
<!--      <div *ngIf="expandedElement?.promotions?.length ? expandedElement?.promotions?.length! > 0 : false">-->
<!--        <mat-divider class="mat-divider-margin"></mat-divider>-->
<!--        <mat-list-item> {{ 'ORDERS.DASHBOARD.DIGITAL_PROMOTIONS' | translate }}: </mat-list-item>-->
<!--        <mat-divider class="mat-divider-margin"></mat-divider>-->

<!--        <mat-list-item *ngFor="let promotion of expandedElement?.promotions; let i = index">-->
<!--          <div *ngIf="promotion.download_url">-->
<!--            <button-->
<!--              mat-button-->
<!--              [disabled]="promotionsCurrentlyDownloading.includes(i)"-->
<!--              (click)="downloadArticle(promotion.download_url, i)"-->
<!--              [class.button-spinner]="promotionsCurrentlyDownloading.includes(i)"-->
<!--            >-->
<!--              {{ promotion.attribute_name }}-->
<!--            </button>-->
<!--          </div>-->
<!--        </mat-list-item>-->
<!--        <mat-divider class="mat-divider-margin" />-->
<!--      </div>-->
<!--    </mat-list>-->
<!--  </mat-sidenav>-->
<!--  <mat-sidenav-content>-->
<!--    <mat-list class="orders-list">-->
<!--      @for (element of (dataSource.filteredData | sortOrder); track element) {-->
<!--      <mat-list-item (click)="openDetailView(element); sidenav.open()">-->
<!--        <span matListItemTitle>{{ element.name }}</span>-->
<!--        @if (element.startDate) {-->
<!--        <span matListItemLine>-->
<!--          {{-->
<!--            element?.type !== 'ORDER'-->
<!--              ? ('ORDERS.DASHBOARD.STARTDATE' | translate)-->
<!--              : ('ORDERS.DASHBOARD.ORDERDATE' | translate)-->
<!--          }}:-->
<!--          {{ element?.type !== 'ORDER' ? element.startDate : formatArticleDate(element.startDate) }}-->
<!--        </span>-->
<!--        }-->
<!--        <span matListItemLine>-->
<!--          <button mat-button (click)="openDetailView(element); sidenav.open()">-->
<!--            {{ 'ORDERS.DASHBOARD.SEE_MORE' | translate }}-->
<!--          </button>-->
<!--        </span>-->
<!--      </mat-list-item>-->
<!--      @if (!$last) { <mat-divider /> } }-->
<!--    </mat-list>-->
<!--  </mat-sidenav-content>-->
<!--</mat-sidenav-container>-->
